export default function AttendanceStatusCard({ employees = [], statusType }) {
  const getInitials = (name) =>
    name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase() || "?";

  const colorClasses = {
    green: "emerald",
    orange: "orange",
    red: "red",
    blue: "blue",
  };

  return (
    <div className="flex grid grid-cols-2 gap-3">
      {employees.map((user, i) => {
        let badgeText = "";

        if (statusType === "Present" || statusType === "Late") {
          badgeText = user.time || "";
        } else if (statusType === "Absent") {
          badgeText = "Absent";
        } else if (statusType === "On Leave") {
          badgeText = user.leaveType || "On Leave";
        }

        return (
          <div
            key={i}
            className={`p-4 rounded-xl card-border-s ${statusType
              .toLowerCase()
              .replace(/\s+/g, "-")}`}
          >
            <div className="flex items-center justify-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full font-semibold text-[12px] avatar">
                {getInitials(user.name)}
              </div>

              <div className="flex-1">
                <p className="font-semibold text-[13px]">{user.name}</p>
                <p className="text-[11px] text-black/50">{user.role}</p>
              </div>

              {badgeText && <div className="shrink-0 font-semibold text-[11px] rounded-xl px-2 py-0.5 card-status">{badgeText}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
